class FixedBtn {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    const thisEle = '.' + this.el
    const mm = gsap.matchMedia();
    mm.add('(max-width:768px)', () => {
      gsap.to(thisEle,{
        bottom: '1.5rem',
        scrollTrigger: {
          trigger: 'body',
          start: '+=300',
          end: '+=500',
          toggleActions: 'play none reverse none'
        }
      })
    })
    mm.add('(min-width:769px)', () => {
      gsap.to(thisEle,{
        bottom: '2.5rem',
        scrollTrigger: {
          trigger: 'body',
          start: '+=300',
          end: '+=500',
          toggleActions: 'play none reverse none'
        }
      })
    })
  }
}
